import React, { Component } from "react"
import createFilterOptions from "react-select-fast-filter-options"
import Select from "react-select"
export default class SelectCustom extends Component {
  shouldComponentUpdate(nextProps) {
    var shouldUpdate = false
    Object.keys(nextProps).forEach(key => {
      var currentProp = this.props[key]
      var nextProp = nextProps[key]
      if (shouldUpdate === false) {
        shouldUpdate = !(nextProp === currentProp)
      }
    })
    return shouldUpdate
  }

  render() {
    var options = this.props.options
    var filterOptions = createFilterOptions({ options })
    return (
      <div className={this.props.sizeClass}>
        <div className="form-group label-floating">
          <label className="control-label">{this.props.label}</label>
          <Select
            placeholder={this.props.placeholder}
            noResultsText="Nenhum resultado"
            filterOptions={filterOptions}
            options={options}
            value={this.props.value}
            onChange={this.props.onChange}
          />
          <span className="label label-danger">{this.props.error}</span>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SelectWithSearch.js